import { team } from '../common/config/constants';
import Footer from '../components/Footer/Footer';
import Navbar from "../components/Navbar/Navbar";

const GroupMembers = () => {

    return (
        <>
            <Navbar />
            {/* Current Members Section */}
            <div className="container shadow-lg">
                <h1>Current Members</h1>

                {/* Doctoral Students */}
                <h2 className="mt-4">Doctoral Students</h2>
                <table className="table table-striped table-responsive">
                    <thead>
                        <tr>
                            <th scope="col">Photo</th>
                            <th scope="col">Details</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            team.currentMembers?.doctoralStudents?.length > 0 ? (
                                team.currentMembers.doctoralStudents.map((item, index) => (
                                    <tr key={`doctoral-${index}`}>
                                        <td>
                                            <img 
                                                src={item.src} 
                                                alt={`Doctoral Student ${index + 1}`} 
                                                className="img-fluid" 
                                                style={{ width: "1000px", height: "350px", objectFit: "cover", borderRadius: "8px" }} 
                                            />
                                        </td>
                                        <td style={{ fontSize: "18px" }}>{item.text}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="2">No doctoral students found.</td>
                                </tr>
                            )
                        }
                    </tbody>
                </table>

                {/* Postdoctoral Students */}
                <h2 className="mt-4">Postdoctoral Students</h2>
                <table className="table table-striped table-responsive">
                    <thead>
                        <tr>
                            <th scope="col">Photo</th>
                            <th scope="col">Details</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            team.currentMembers?.postDocStudents?.length > 0 ? (
                                team.currentMembers.postDocStudents.map((item, index) => (
                                    <tr key={`postdoc-${index}`}>
                                        <td>
                                            <img 
                                                src={item.src} 
                                                alt={`Postdoctoral Student ${index + 1}`} 
                                                className="img-fluid" 
                                                style={{ width: "700px", height: "250px", objectFit: "cover", borderRadius: "8px" }} 
                                            />
                                        </td>
                                        <td>{item.text}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="2">You could be next!! Contact PI.</td>
                                </tr>
                            )
                        }
                    </tbody>
                </table>

                {/* Masters Students */}
                <h2 className="mt-4">Masters Students</h2>
                <table className="table table-striped table-responsive">
                    <thead>
                        <tr>
                            <th scope="col">Photo</th>
                            <th scope="col">Details</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            team.currentMembers?.mastersStudents?.length > 0 ? (
                                team.currentMembers.mastersStudents.map((item, index) => (
                                    <tr key={`masters-${index}`}>
                                        <td>
                                            <img 
                                                src={item.src} 
                                                alt={`Masters Student ${index + 1}`} 
                                                className="img-fluid" 
                                                style={{  width: "700px", height: "250px", objectFit: "cover", borderRadius: "8px" }}
                                            />
                                        </td>
                                        <td>{item.text}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="2">No masters students found.</td>
                                </tr>
                            )
                        }
                    </tbody>
                </table>

                {/* Interns */}
                <h2 className="mt-4">Interns</h2>
                <table className="table table-striped table-responsive">
                    <thead>
                        <tr>
                            <th scope="col">Photo</th>
                            <th scope="col">Details</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            team.currentMembers?.interns?.length > 0 ? (
                                team.currentMembers.interns.map((item, index) => (
                                    <tr key={`intern-${index}`}>
                                        <td>
                                            <img 
                                                src={item.src} 
                                                alt={`Intern ${index + 1}`} 
                                                className="img-fluid" 
                                                style={{ maxWidth: "300px", maxHeight: "300px" }}
                                            />
                                        </td>
                                        <td>{item.text}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="2">You could be next!!Contact us.</td>
                                </tr>
                            )
                        }
                    </tbody>
                </table>
            </div>

            {/* Past Members Section */}
            <div className="container my-5">
                <h1>Past Members</h1>
                <table className="table table-striped table-responsive">
                    <tbody>
                        {/* Doctoral Students */}
                        <tr>
                            <td colSpan="2" className="border-bottom border-primary text-primary">Doctoral Students</td>
                        </tr>
                        {
                            team?.pastMembers?.doctoralStudents?.length > 0 ? (
                                team.pastMembers.doctoralStudents.map((item, index) => (
                                    <tr key={`doctoral-${index}`}>
                                        <td>{item.name}</td>
                                        <td>{item.details}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="2">No doctoral students found.</td>
                                </tr>
                            )
                        }

                        {/* Postdoctoral Students */}
                        <tr>
                            <td colSpan="2" className="border-bottom border-primary text-primary">Post Doctoral Students</td>
                        </tr>
                        {
                            team?.pastMembers?.postDocStudents?.length > 0 ? (
                                team.pastMembers.postDocStudents.map((item, index) => (
                                    <tr key={`postdoc-${index}`}>
                                        <td>{item.name}</td>
                                        <td>{item.details}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="2">No postdoctoral students found.</td>
                                </tr>
                            )
                        }

                        {/* Master Students */}
                        <tr>
                            <td colSpan="2" className="border-bottom border-primary text-primary">Master Students</td>
                        </tr>
                        {
                            team?.pastMembers?.masterStudents?.length > 0 ? (
                                team.pastMembers.masterStudents.map((item, index) => (
                                    <tr key={`master-${index}`}>
                                        <td>{item.name}</td>
                                        <td>{item.details || "Details not available"}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="2">No master students found.</td>
                                </tr>
                            )
                        }

                        {/* Interns */}
                        <tr>
                            <td colSpan="2" className="border-bottom border-primary text-primary">Interns</td>
                        </tr>
                        {
                            team?.pastMembers?.interns?.length > 0 ? (
                                team.pastMembers.interns.map((item, index) => (
                                    <tr key={`intern-${index}`}>
                                        <td>{item.name}</td>
                                        <td>{item.details || "Details not available"}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="2">No interns found.</td>
                                </tr>
                            )
                        }
                    </tbody>
                </table>
            </div>
            <Footer />
        </>
    );
};

export default GroupMembers;